export default {
      id: "death-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#death",
      toString: function () {
        return this.url;
      }
    }